export default {
  //apiUrl: "https://localhost:44372/api",
  //apiUrl: "https://uatapi.paratic.com.tr/api",
  apiUrl: "https://api.isimicin.co/api",
  apiContentUrl: "https://api.isimicin.co/Content/CardLogo",
  //apiUrl: "https://api.digitalkobi.com/api",
  headers: {
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  },
  frontEndUrl: "https://isimicin.co/",
  //demoUrl: "https://localhost:44351/",
  demoUrl: "https://isimicin.co/",
  eInvoiceUrl:"https://api.isimicin.co/",
  //demoUrl: "https://www.finekra.com/",
  //frontEndUrl: "http://localhost:3000/",
  // frontEndUrl: "https://panel.paratic.com.tr/",
  //frontEndUrl: "https://ykb.finekra.com/",
  //supportPanelImgUrl: "https://localhost:44391",
  supportPanelImgUrl: "https://api.isimicin.co",
  renderNotifications: false,
};
